// extracted by mini-css-extract-plugin
export default {"close-button":"close-button--AU5Ut","closeButton":"close-button--AU5Ut"};